import { useState } from "react";
import useSiteRegion from "../hooks/useSiteRegion";

const MAIN_SITE = "https://deliva-for-web.vercel.app";
const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.delivait.app";

const NAV_LINKS = [
  { label: "Home", href: `${MAIN_SITE}/` },
  { label: "Deals", href: `${MAIN_SITE}/near-me` },
  { label: "Advertise", href: "/", active: true },
  { label: "Support", href: `${MAIN_SITE}/support` },
  { label: "Account", href: `${MAIN_SITE}/account` },
];

const RegionFlag = ({ region }) => (
  <span className="site-header-flag">
    <img key={region.code} src={region.flag} alt={region.label} title={region.label} />
  </span>
);

const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const region = useSiteRegion();
  const barClass = open ? "bar is-open" : "bar";

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <a href={`${MAIN_SITE}/`} className="site-header-logo">
          <img src="/deliva-logo.svg" alt="Deliva Logo" />
        </a>

        <nav className="site-header-nav">
          <ul>
            {NAV_LINKS.map(({ label, href, active }) => (
              <li key={label}>
                <a href={href} aria-current={active ? "page" : undefined}>
                  {label}
                  <span className={active ? "underline is-active" : "underline"} aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>

          <div className="site-header-actions">
            <a
              href={PLAY_STORE}
              target="_blank"
              rel="noopener noreferrer"
              className="site-header-download"
            >
              Download
            </a>
            <RegionFlag region={region} />
          </div>
        </nav>

        <div className="site-header-compact">
          <a
            href={PLAY_STORE}
            target="_blank"
            rel="noopener noreferrer"
            className="site-header-download"
          >
            Download
          </a>
          <RegionFlag region={region} />
          <button
            type="button"
            className="site-header-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span className="site-header-icon">
              <span className={`${barClass} bar-top`} />
              <span className={`${barClass} bar-middle`} />
              <span className={`${barClass} bar-bottom`} />
            </span>
          </button>
        </div>
      </div>

      {open && (
        <nav className="site-header-mobile">
          {NAV_LINKS.map(({ label, href, active }) => (
            <a
              key={label}
              href={href}
              aria-current={active ? "page" : undefined}
              onClick={() => setOpen(false)}
            >
              {label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default SiteHeader;
